import * as S from './styles';

import Switch from '@components/Common/Switch';
import TrendlineIcon from '@svgIcons/trendline.svg';
import InfoLineIcon from '@svgIcons/widget_info.svg';

import PanelOptionMixin from '../mixin';

import { CHART_TYPES } from '@/utils/consts';

const { HORIZONTAL_BAR, BAR } = CHART_TYPES;

export default {
    name: 'TrendlineToggleOption',
    mixins: [PanelOptionMixin],
    props: {
        showTrendline: { type: Boolean, default: false },
    },
    computed: {
        shouldShowTrendlineOption: R.compose(
            R.includes(R.__, [HORIZONTAL_BAR, BAR]),
            R.pathOr('', ['graphOptions', 'selectedGraphType'])
        ),
    },
    render() {
        const { shouldShowTrendlineOption, showTrendline } = this;

        return (
            shouldShowTrendlineOption && (
                <S.ComponentWrapper>
                    <div class="top-wrapper">
                        <div class="title">
                            <TrendlineIcon class="trendline-icon" />
                            <h3>
                                {this.$t(
                                    'NEW_DASHBOARD.trendline_toggle_option_title'
                                )}
                            </h3>
                            {this.wrapTooltip({
                                visible: true,
                                content: (
                                    <InfoLineIcon class="info-line-icon" />
                                ),
                                title: this.$t(
                                    'NEW_DASHBOARD.trendline_toggle_option_tooltip'
                                ),
                            })}
                        </div>
                        <Switch
                            value={showTrendline}
                            type="big"
                            onClick={() => {
                                this.$emit('update', !showTrendline);
                            }}
                        />
                    </div>
                </S.ComponentWrapper>
            )
        );
    },
};
